import { TIMEOUT_HIDDEN_TOAST_MESSAGE } from "components/ToastMessage/ToastMessage";
import { useState } from "react";
import { INIT_TOAST_MESSAGE } from "../constants";
import { wait } from "utils/others";

const useToastMessage = props => {
    const { message, timeoutToHideAfterShow } = props || {
        message: "",
        timeoutToHideAfterShow: null
    }
    //#region States
    const [toastMessage, setToastMessage] = useState({ 
        ...INIT_TOAST_MESSAGE,
        message
    });
    //#endregion
    //#region Functions
    const hide = () => {
        setToastMessage(prev => ({
            ...prev,
            hidden: true
        }));
    }
    const show = async (newMessage = message, variant = null, milis = null) => {
        const newValue = {
            hidden: false,
            message: newMessage || "" ,
            variant
        };
        setToastMessage({ ...newValue });
        await wait(milis || timeoutToHideAfterShow || TIMEOUT_HIDDEN_TOAST_MESSAGE);
        newValue.hidden = true;
        setToastMessage({ ...newValue });
    }
    const toggleHidden = () => {
        setToastMessage(prev => ({
            ...prev,
            hidden: !prev.hidden
        }));
    }
    //#endregion
    return {
        value: {
            ...toastMessage,
            toggleHidden
        },
        hide, show
    };
}

export default useToastMessage;